import { Tag } from "antd";

import { patientListStatusTagColor } from "#modules/patient/patientNestedModuleListConfig";

const PBM_PORTAL_PATIENT_TABLE_COLUMNS = [
	"external_id",
	"firstname",
	"status",
	"dob",
	"plan_id",
] as const;

const PBM_PORTAL_PATIENT_TABLE_FILTERS = [
	"firstname",
	"dob",
	"external_id",
	"patient_status",
] as const;

export const pbmPortalPatientEntityDefOverride = {
	ui: {
		table: {
			columns: [...PBM_PORTAL_PATIENT_TABLE_COLUMNS],
			sort: [ "firstname"],
			filters: [...PBM_PORTAL_PATIENT_TABLE_FILTERS],
		},
	},
};

export const pbmPortalPatientListConfig = {
	entityColOverride: {
		status: {
			render: (value: string) => (
				<Tag color={patientListStatusTagColor(value)}>{value}</Tag>
			),
		},
	},
	entityDefOverride: pbmPortalPatientEntityDefOverride,
};
